import { useTu } from "@src/appV2/i18n/useTu";
import { type TimeSlot } from "@src/appV2/redesign/Shift/types";

import { SegmentedControl } from "../../components/SegmentedControl";
import { LabeledField } from "./LabeledField";

interface ShiftTypeToggleProps {
  value: TimeSlot;
  onChange: (timeSlot: TimeSlot) => void;
}

/**
 * AM / PM / NOC shift-type selector for the Add Shift panel.
 */
export function ShiftTypeToggle(props: ShiftTypeToggleProps) {
  const { tu } = useTu("schedule");
  const { value, onChange } = props;

  return (
    <LabeledField label={tu("Shift type")}>
      <SegmentedControl<TimeSlot>
        ariaLabel={tu("Shift type")}
        labelTextTransform="none"
        options={[
          { value: "am", label: tu("AM") },
          { value: "pm", label: tu("PM") },
          { value: "noc", label: tu("NOC") },
        ]}
        value={value}
        onChange={onChange}
      />
    </LabeledField>
  );
}
